import i18n, { LANGUAGE_STORAGE_KEY } from "./index";
import { fetcher } from "../utils/fetcher";
import useAuthStore from "../store/authStore";

const storeOnDevice = (language) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Storage unavailable (e.g. private mode) - the language still applies
  }
};

// Saved on the account so emails and push notifications use it too
const saveOnAccount = async (language) => {
  const { user } = useAuthStore.getState();
  if (!user) return;
  useAuthStore.setState({ user: { ...user, language } });
  try {
    await fetcher.put("/api/auth/language", { language });
  } catch (err) {
    console.error("Error saving language:", err);
  }
};

// The user picked a language in settings
export const setLanguage = async (language) => {
  storeOnDevice(language);
  await i18n.changeLanguage(language);
  await saveOnAccount(language);
};

// Use a language saved on the account (also when it was changed on another
// device - the server sends "user:language")
export const applyLanguage = (language) => {
  const { user } = useAuthStore.getState();
  if (user && user.language !== language) {
    useAuthStore.setState({ user: { ...user, language } });
  }
  if (language !== i18n.resolvedLanguage) {
    storeOnDevice(language);
    i18n.changeLanguage(language);
  }
};

// The account's language wins (it may have been changed on another device);
// an account without one gets the language the app is using now (the
// browser's, or one picked before login). Called on start/login and when the
// app comes back to the foreground.
export const refreshAccountLanguage = async () => {
  if (!useAuthStore.getState().user) return;
  try {
    const { language } = await fetcher.get("/api/auth/language");
    if (language) {
      applyLanguage(language);
    } else {
      saveOnAccount(i18n.resolvedLanguage);
    }
  } catch (err) {
    console.error("Error loading language:", err);
  }
};
